import React, { useState } from "react";

export default function Surveys() {
  const [surveys, setSurveys] = useState([]);
  const [newSurvey, setNewSurvey] = useState({
    title: "",
    questions: [],
    anonymous: false,
    course: "",
  });
  const [newQuestion, setNewQuestion] = useState("");
  const [questionType, setQuestionType] = useState("single");

  const [courses] = useState(["Safety Training", "Customer Service", "Cyber Security"]);

  const addQuestion = () => {
    if (newQuestion.trim()) {
      setNewSurvey((prev) => ({
        ...prev,
        questions: [...prev.questions, { text: newQuestion, type: questionType }],
      }));
      setNewQuestion("");
    }
  };

  const saveSurvey = () => {
    if (!newSurvey.title || !newSurvey.course || newSurvey.questions.length === 0) return;
    setSurveys((prev) => [...prev, newSurvey]);
    setNewSurvey({ title: "", questions: [], anonymous: false, course: "" });
  };

  const deleteSurvey = (index) => {
    const updated = [...surveys];
    updated.splice(index, 1);
    setSurveys(updated);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-8">
      <h2 className="text-2xl font-bold">Create Survey</h2>

      <div className="space-y-4 bg-white p-6 rounded shadow border">
        <input
          type="text"
          placeholder="Survey Title"
          value={newSurvey.title}
          onChange={(e) => setNewSurvey({ ...newSurvey, title: e.target.value })}
          className="w-full border rounded px-3 py-2"
        />

        <select
          value={newSurvey.course}
          onChange={(e) => setNewSurvey({ ...newSurvey, course: e.target.value })}
          className="w-full border rounded px-3 py-2"
        >
          <option value="">Assign to Course</option>
          {courses.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>

        <label className="inline-flex items-center">
          <input
            type="checkbox"
            checked={newSurvey.anonymous}
            onChange={(e) => setNewSurvey({ ...newSurvey, anonymous: e.target.checked })}
            className="mr-2"
          />
          Anonymous Responses
        </label>

        <div className="space-y-2">
          <h4 className="font-semibold">Add Question</h4>
          <input
            type="text"
            placeholder="Question text"
            value={newQuestion}
            onChange={(e) => setNewQuestion(e.target.value)}
            className="w-full border rounded px-3 py-2"
          />
          <div className="flex gap-4 items-center">
            <select
              value={questionType}
              onChange={(e) => setQuestionType(e.target.value)}
              className="border rounded px-3 py-2"
            >
              <option value="single">Multiple Choice (Single Answer)</option>
              <option value="multi">Multiple Response</option>
            </select>
            <button
              onClick={addQuestion}
              className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
            >
              Add Question
            </button>
          </div>
        </div>

        <ul className="space-y-2">
          {newSurvey.questions.map((q, i) => (
            <li key={i} className="border p-2 rounded">
              {i + 1}. {q.text} ({q.type === "single" ? "MCQ" : "Multi-response"})
            </li>
          ))}
        </ul>

        <button
          onClick={saveSurvey}
          disabled={!newSurvey.title || !newSurvey.course || newSurvey.questions.length === 0}
          className="mt-4 bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 disabled:opacity-50"
        >
          Save Survey
        </button>
      </div>

      {/* Existing Surveys */}
      <div className="space-y-4">
        <h3 className="text-xl font-semibold">Saved Surveys</h3>
        {surveys.length === 0 ? (
          <p className="text-gray-500">No surveys created yet.</p>
        ) : (
          <ul className="space-y-2">
            {surveys.map((s, index) => (
              <li key={index} className="bg-gray-100 p-4 rounded shadow flex justify-between items-start">
                <div>
                  <strong>{s.title}</strong> <span className="text-sm text-gray-600">({s.course})</span>
                  <ul className="mt-2 list-disc pl-5 text-sm">
                    {s.questions.map((q, i) => (
                      <li key={i}>
                        {q.text} ({q.type === "single" ? "MCQ" : "Multi"})
                      </li>
                    ))}
                  </ul>
                  {s.anonymous && <p className="text-xs mt-2 italic text-gray-500">Anonymous Survey</p>}
                </div>
                <button
                  onClick={() => deleteSurvey(index)}
                  className="text-red-600 text-sm hover:underline"
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
